interface Props {
  src: string;
  onClose: () => void;
}

export default function Lightbox({ src, onClose }: Props) {
  return (
    <div
      className="fixed inset-0 bg-black/80 flex items-center justify-center z-[200] p-4"
      onClick={onClose}
    >
      <button onClick={onClose}
        className="absolute top-4 right-4 text-white text-3xl leading-none hover:text-gray-300">×</button>
      <img
        src={src}
        alt=""
        onClick={e => e.stopPropagation()}
        className="max-w-[80vw] max-h-[90vh] object-contain rounded-lg shadow-2xl"
      />
    </div>
  );
}
